const VITE_CLOUD_VERSION = import.meta.env.VITE_CLOUD_VERSION ?? 'unknown'
const VITE_PACKAGE_VERSION = __APP_VERSION__ ?? 'unknown'

export const CLOUD_PACKAGE_VERSION = `${VITE_PACKAGE_VERSION}+${VITE_CLOUD_VERSION}`
